import validate from "/home/runner/work/virgo/virgo/website/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  protected: () => import("/home/runner/work/virgo/virgo/website/middleware/protected.ts"),
  unprotected: () => import("/home/runner/work/virgo/virgo/website/middleware/unprotected.ts")
}